import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'vault-table-toolbar',
  templateUrl: './table-toolbar.component.html',
  styleUrls: ['./table-toolbar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class TableToolbarComponent {}
